export default __webpack_public_path__ + "static/media/Claude_Monet_The_Japanese_bridge_50_x_70_cm.66b41d5f.jpg";